import { EncryptionModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface EncryptionModuleFormValue {
  uiSettings: { encryption: EncryptionModule };
}

// searchable keywords
export enum EncryptionSearchKeywords {
  EncryptionManagement = 'EncryptionManagement',
  Decrypt = 'Decrypt',
  Encrypt = 'Encrypt',
  TrustedPlatformModule = 'TrustedPlatformModule',
  Tpm = 'Tpm',
  Exclusions = 'Exclusions',
}
